import BeginningBalanceActions from './actions';

const INITIAL_STATE = {
  data: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  showModal:false,
  onSubmit:false,
  single:null,
  helperBeginningBalance:[],
  errorInternal:false
};

function Coa3Reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case BeginningBalanceActions.RESET_LIST:
      return INITIAL_STATE;
    case BeginningBalanceActions.NEW_DATA:
      return { ...state,errorInternal:false,  errorMessage: [],onSubmit:false, isProcessing: false,single:null, form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case BeginningBalanceActions.UPDATE_DATA:
      return { ...state, errorInternal:false, errorMessage: [],onSubmit:false,isProcessing: false, single:null,isNewRecord:false};
    case BeginningBalanceActions.VIEW_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:action.payload,isNewRecord:false,showModal:true};
    case BeginningBalanceActions.RESET_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case BeginningBalanceActions.DELETE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case BeginningBalanceActions.ON_SUBMIT:
      return { ...state, errorInternal:false,onSubmit:true};
    case BeginningBalanceActions.SHOW_DATA:
      return { ...state, errorInternal:false,onSubmit:false, isError: false, data: action.payload, errorMessage: [],isProcessing:false };
    case BeginningBalanceActions.ERROR_DATA:
      return { ...state, errorInternal:false, isError: true,onSubmit:false,  errorMessage: action.payload,isProcessing:false };
    case BeginningBalanceActions.SUCCESS_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isError: false, showModal:false,form:INITIAL_STATE.form , onSubmit:false};
    case BeginningBalanceActions.PROCESS_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: true, isError: false,isSuccess:false};
     case BeginningBalanceActions.GET_HELPER_COA3:
       return { ...state,errorInternal:false, isError: false,isSuccess:false,onSubmit:false,helperBeginningBalance:action.payload};
    case BeginningBalanceActions.ERROR_SERVER:
      return { ...state,  isError: false, errorInternal:true, onSubmit:false,  errorMessage: action.payload, isProcessing:false };
       
    default:
      return state;
    }
}

export default Coa3Reducer;
